module.exports = __webpack_public_path__ + "static/media/  (43).8f5be49d.jpg";